import React from "react";
import { Link } from "react-router-dom";
import { Player } from "@lottiefiles/react-lottie-player";
import { FaNodeJs, FaReact } from "react-icons/fa6";
import { TbBrandNextjs } from "react-icons/tb";
import { SiTailwindcss, SiFirebase } from "react-icons/si";

// "https://deveshgpt.netlify.app"

const project = () => {
  return (
    <>
      <section class="text-gray-400  body-font mx-5 my-5 p-10 border-2 border-indigo-500  drop-shadow-lg rounded-lg shadow-lg shadow-indigo-600/60">
        <div class="container px-5 py-10 mx-auto">
          {/* PROJECT ONE */}

          <div class="flex items-center lg:w-3/5 mx-auto border-b pb-10 mb-10 border-gray-300 sm:flex-row flex-col">
            <div class="sm:w-32 sm:h-32 h-30 w-30 sm:mr-10 inline-flex items-center justify-center rounded-full text-purple-400 bg-gray-800 flex-shrink-0">
              <Player
                src="https://assets1.lottiefiles.com/packages/lf20_myejiggj.json"
                style={{ height: "150px", width: "150px" }}
                className="player"
                loop
                autoplay
              />
            </div>
            <div class="flex-grow sm:text-left text-center mt-6 sm:mt-0">
              <h2 class="text-indigo-600 text-lg title-font font-medium mb-5 mt-5 underline">
                <Link to="https://deveshgpt.netlify.app">Used OpenAI API</Link>
              </h2>
              <p class="leading-relaxed text-base">
                Introducing our mini ChatGPT app! It's the perfect way to get a
                taste of AI chatbots without breaking the bank.
              </p>
              <h4 class="mt-3 text-indigo-500 inline-flex items-center text-sm pt-5">
                Tech Used:{" "}
                <p class="flex text-gray-500 font-semibold ml-2">
                  <FaNodeJs size={32} color="green" class="m-1" />
                  <TbBrandNextjs size={32} color="black" class="m-1" />
                </p>
              </h4>
            </div>
          </div>

          {/* PROJECT TWO */}

          <div class="flex items-center lg:w-3/5 mx-auto mb-10 border-b pb-10 sm:flex-row flex-col">
            <div class="flex-grow sm:text-left text-center mt-6 sm:mt-0">
              <h2 class="text-indigo-600 text-lg title-font font-medium mb-5 mt-5 underline">
                <Link to="https://devesh-project.vercel.app">
                  ToDo App using Firebase
                </Link>
              </h2>
              <p class="leading-relaxed text-base">
                Get more done with our to-do app! Sign in with Google and start
                creating tasks in seconds. Mark tasks complete as you go, and
                never miss a deadline again.
              </p>
              <h4 class="mt-3 text-indigo-500 inline-flex items-center text-sm pt-5">
                Tech Used:
                <p class="flex  text-gray-500 font-semibold ml-2 ">
                  <TbBrandNextjs size={32} color="black" class="m-1" />
                  <SiTailwindcss size={32} color="#3490dc" class="m-1" />
                  <SiFirebase size={32} color="#FFA611" class="m-1" />
                </p>
              </h4>
            </div>

            <div class="sm:w-32 order-first sm:order-none sm:h-32 h-40 w-40 sm:ml-10 inline-flex items-center justify-center rounded-full text-purple-400 bg-gray-800 flex-shrink-0">
              <Player
                src="https://lottie.host/59fc6785-97f2-4be1-8483-9a6b1f470603/Loa8LGN2gg.json"
                style={{ height: "190px", width: "190px" }}
                className="player pb-15"
                loop
                autoplay
                background=""
                direction={-2}
              />
            </div>
          </div>

          {/* PROJECT THREE */}

          <div class="flex items-center lg:w-3/5 mx-auto border-b pb-10 mb-10 border-gray-300 sm:flex-row flex-col">
            <div class="sm:w-32 sm:h-32 h-30 w-30 sm:mr-10 inline-flex items-center justify-center rounded-full text-purple-400 bg-gray-800 flex-shrink-0">
              <Player
                src="https://lottie.host/937d5cb4-5040-40d4-879d-80b1559b7777/OkpQwFusAG.json"
                style={{ height: "150px", width: "150px" }}
                className="player "
                loop
                autoplay
              />
            </div>
            <div class="flex-grow sm:text-left text-center mt-6 sm:mt-0">
              <h2 class="text-indigo-600 text-lg title-font font-medium mb-5 mt-5 underline">
                <Link to="https://651710f4e86c39085582465e--devesh-portfolio-web.netlify.app">
                  Random Gradient Color Generator
                </Link>
              </h2>
              <p class="leading-relaxed text-base">
              Click and see the gradient rainbow🌈 unfold!
              </p>
              <h4 class="mt-3 text-indigo-500 inline-flex items-center text-sm pt-5">
                Tech Used:{" "}
                <p class="flex text-gray-500 font-semibold ml-2 ">
                  <FaReact size={32} color={"#61DBFB"} class="m-1" />
                </p>
              </h4>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default project;
